import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// config
import { defaultLang } from '../config';
//
import enLocales from './en';
/* import frLocales from './fr';
import vnLocales from './vn';
import cnLocales from './cn';
import arLocales from './ar'; */
import skLocales from './sk';

// ----------------------------------------------------------------------
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enLocales },
      sk: { common: skLocales },
      /* fr: { translations: frLocales },
      vn: { translations: vnLocales },
      cn: { translations: cnLocales },
      ar: { translations: arLocales }, */
    },
    lng: window.location.pathname.startsWith('/en') ? 'en' : defaultLang.value, // fallbackLng: defaultLang.value,
    debug: false,
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
